<template>
    <div class="section-box people">
        <el-tabs v-model="tap" type="card" class="customer-tabs-mg" :before-leave="tabSelect"
            @tab-click="getConfigList">
            <el-tab-pane v-for="(item, index) in tapArr" :label="item.value" :name="item.key + ''"
                :key="index"></el-tab-pane>
        </el-tabs>

        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col style="width:200px;">
                    <el-form inline label-width="90px" label-position="left" style="text-align: left;   ">
                        <el-form-item>
                            <el-button size="medium" type="primary" class="search_btn"
                                @click="showAddDia">添加</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <!-- 列表 -->
        <el-table :stripe="true" :data="tableData" style="width: 100%;" border v-loading="listLoading"
            :header-cell-style="{ background: '#F5F7FA' }">
            <!-- eslint-disable  -->
            <el-table-column label="可匹配单数">
                <template slot-scope="scope">
                    <span>{{ scope.row.MaxJobCount || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="已匹配单数">
                <template slot-scope="scope">
                    <span>{{ scope.row.DistributedJobCount }}</span>
                </template>
            </el-table-column>
            <el-table-column label="人员">
                <template slot-scope="scope">
                    <span>{{ scope.row.ManageUserName || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.ActivateStatus" @change="updateActivateStatus(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="showUpdateDia(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="添加" :visible.sync="showDia" width="600px" :destroy-on-close="false"
            :close-on-click-modal="true">
            <el-form label-position="left" label-width="120px">
                <el-form-item label="可匹配单数" required>
                    <el-input v-model="form.MaxJobCount" placeholder="可匹配单数"></el-input>
                </el-form-item>
                <el-form-item label="人员" required>
                    <el-select v-model.trim="form.ServiceManageUserId" :disabled="diaIndex === 2" placeholder="请选择"
                        style="width: 100%;">
                        <el-option :value="0" :label="'请选择'"></el-option>
                        <el-option :value="item.UserId" :label="item.RealName" v-for="(item, index) in djrArr"
                            :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" required>
                    <el-radio v-model="form.ActivateStatus" :label="true">启用</el-radio>
                    <el-radio v-model="form.ActivateStatus" :label="false">禁用</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="showDia = false" :loading="addLoading">取 消</el-button>
                <el-button type="primary" @click="saveConfig()" :loading="addLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    getConfigList,       //个人列表
    saveConfig,        //搜搜公司
    updateActivateStatus,           //搜索用户
    getTakeOverUserList
} from "@/service/job";
export default {
    data() {
        return {
            tapArr: [{
                key: 1,
                value: "派单管理",
            }, {
                key: 2,
                value: "值班人员配置",
            }],
            tap: '1',
            tableData: [],
            listLoading: false,
            djrArr: [],  //对接人列表
            diaIndex: 0,
            addLoading: false,
            showDia: false,
            form: {
                Id: 0,
                MaxJobCount: "",
                ServiceManageUserId: 0,
                ServiceManageUserName: "",
                ActivateStatus: true
            },


        }
    },
    created() {
        this.tableData = [];
    },
    mounted() {
        this.getConfigList();
        this.getTakeOverUserListFun();
    },

    methods: {
        //切换tab之前
        tabSelect(activeName, oldActiveName) {
            console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
            if (activeName == "2") {
                this.$router.push('/distributeJob/dutyConfig');
                return false;
            }
            else {
                return true;
            }
        },

        // 获取列表状态
        async getConfigList() {
            this.listLoading = true
            let data = {}
            let res = await getConfigList(data)
            this.listLoading = false
            if (res.Result != 1) {
                return this.$message.error(res.Message)
            }
            this.tableData = res.Data;

            console.log('tableData:' + JSON.stringify(this.tableData))
        },
        // 获取对接人
        getTakeOverUserListFun() {
            getTakeOverUserList().then(res => {
                this.djrArr = res.Data;
            })
        },
        showAddDia() {
            this.form.Id = 0;
            this.form.MaxJobCount = "";
            this.form.ServiceManageUserId = 0;
            this.form.ServiceManageUserName = "";
            this.form.ActivateStatus = true;
            
            this.diaIndex = 1;
            this.showDia = true;
        },
        showUpdateDia(row) {
            this.form.MaxJobCount = row.MaxJobCount;
            this.form.ServiceManageUserId = row.ManageUserId;
            this.form.ActivateStatus = row.ActivateStatus;
            this.form.Id = row.Id;
            this.diaIndex = 2;
            this.showDia = true;
        },
        deleteBindingBtn(id) {
            let row = this.tableData.find(d => d.Id == id);
            this.showUpdateDia(row);
        },
        saveConfig() {
            if (!this.form.MaxJobCount) {
                return this.$message.warning('请输入可匹配单数');
            }
            if (!this.form.ServiceManageUserId) {
                return this.$message.warning('请选择人员');
            }

            var into = this.djrArr.filter(d => d.UserId == this.form.ServiceManageUserId);
            if (into.length > 0) {
                this.form.ServiceManageUserName = into[0].RealName;
            }

            console.log('form:' + JSON.stringify(this.form));

            this.addLoading = true;
            saveConfig(this.form).then(res => {
                this.addLoading = false;
                if (res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message);
                this.diaIndex = 0;
                this.showDia = false;
                this.getConfigList();
            });

        },
        updateActivateStatus(row) {
            console.log('row:' + JSON.stringify(row));
            var data = {
                Id: row.Id,
                ActivateStatus: row.ActivateStatus
            };
            updateActivateStatus(data).then(res => {
                if (res.Result != 1) {
                    row.ActivateStatus = !row.ActivateStatus;
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message);
            });
        },



    },
}
</script>
<style lang="scss">
.people {
    .customer-list {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
}
</style>